import { FC } from "react";
import { Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import TicketTemplateForm from "./partials/TicketTemplateForm";
import { useTicketTemplateCreate } from "./hooks";

const TicketTemplateCreate: FC = () => {
  const { form } = useTicketTemplateCreate();

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Create new Ticket Template" />
        </Typography.Title>
      </Header>
      <Space />
      <TicketTemplateForm {...form} />
    </>
  );
};

export default TicketTemplateCreate;
